import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { loadingReducer } from "./reducer/loading";
import { authReducer, changeMobileNumberReducer } from "./reducer/auth";
import { organizationReducer } from "./reducer/organization";
import { notificationsReducer } from "./reducer/notifications";
import { contractsReducer } from "./reducer/contracts";
import { pickupsReducer } from "./reducer/pickupsReducer";
import { generalReducer } from "./reducer/generalReducer";
import groupReducer from "./reducer/group";
import { scrapsReducer } from "./reducer/scrapsReducer";
import { analyticsReducer } from "./reducer/analytics";
import { auctionReducer , liveAuctionListReducer } from "./auction/reducer/auction";
import { auctionVenderReducer , allDocumentsReducer } from "./auction/reducer/venders"
import { productReducer } from "./auction/reducer/product"
import { liveTripsReducer } from "./reducer/liveTrips";


const reducer = combineReducers({
  loading: loadingReducer,
  account: authReducer,
  changeMobileNumber: changeMobileNumberReducer,
  general: generalReducer,
  organization: organizationReducer,
  notifications: notificationsReducer,
  contracts: contractsReducer,
  pickups: pickupsReducer,
  groups: groupReducer,
  scraps: scrapsReducer,
  analytics: analyticsReducer,
  auction: auctionReducer,
  auctionVender: auctionVenderReducer,
  liveAuction:liveAuctionListReducer,
  documents:allDocumentsReducer,
  product: productReducer,
  liveTrips: liveTripsReducer,
});

const initialstate = {};
const middleware = [thunk];
const store = createStore(
  reducer,
  initialstate,
  applyMiddleware(...middleware)
);

export default store;
